import GradientComponent from './gradient-background.component';
export default GradientComponent;
